import { BasicInput } from '@elotech/components';
import { FieldProps, FormikProps } from 'formik';
import { useCallback } from 'react';
import { ArquivoDTO } from 'types';

import { InputFileAvulso } from './InputFileAvulso';

type Props = {
  label: string;
  size?: number;
  fileIdField: string;
  fileNameField: string;
  onBusyChange?: (busy: boolean) => void;
};

export const FormikInputFileAvulso = ({
  label,
  size,
  fileIdField,
  fileNameField,
  onBusyChange
}: Props) => {
  const doChangeFile = useCallback(
    async (form: FormikProps<any>, arquivoDto?: ArquivoDTO) => {
      form.setFieldValue(fileIdField, arquivoDto?.id);
      form.setFieldValue(fileNameField, arquivoDto?.nome);
    },
    [fileIdField, fileNameField]
  );

  const getArquivo = useCallback(
    (form: FormikProps<any>): ArquivoDTO | undefined => {
      const id = form.values?.[fileIdField];
      const nome = form.values?.[fileNameField];
      if (id && nome) {
        return { id, nome };
      }
      return undefined;
    },
    [fileIdField, fileNameField]
  );

  return (
    <BasicInput
      label={label}
      name={fileIdField}
      fast={false}
      size={size}
      render={({ form }: FieldProps) => (
        <InputFileAvulso
          onChangeFile={arquivo => doChangeFile(form, arquivo)}
          arquivo={getArquivo(form)}
          onBusyChange={onBusyChange}
        />
      )}
    />
  );
};
